import { render, staticRenderFns } from "./solicitudHUB.vue?vue&type=template&id=fe42d5ce&scoped=true"
import script from "./solicitudHUB.vue?vue&type=script&lang=js"
export * from "./solicitudHUB.vue?vue&type=script&lang=js"
import style0 from "./solicitudHUB.vue?vue&type=style&index=0&id=fe42d5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe42d5ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
